import { type Address, getAddress, type Hex } from 'viem'

export function maybeGetAddress(address: Address | undefined): Address | undefined {
  return address ? getAddress(address) : undefined
}

/**
 * Classifies account bytecode as an EOA vs a contract.
 *
 * Treats an EIP-7702-delegated EOA — whose code is the `0xef0100 || <target>` designator — as an
 * EOA, unlike a naive "has any bytecode" check that would mislabel it a contract. Absent or empty
 * code is an EOA; any other bytecode is a contract.
 */
export function isEoaBytecode(code: Hex | undefined): boolean {
  return !code || code === '0x' || code.startsWith('0xef0100')
}
